var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.327,
    height: 21.125,
    viewBox: "0 0 17.327 21.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M51.767 134.216c-3.144-.018-5.745-6.436-5.745-9.7 0-5.339 4.005-6.508 5.549-6.508a6.385 6.385 0 0 1 2.094.515 4.68 4.68 0 0 0 1.2.343 3.72 3.72 0 0 0 .858-.278 6.874 6.874 0 0 1 2.585-.625h.006a5.3 5.3 0 0 1 4.434 2.239l.323.486-.465.351a3.916 3.916 0 0 0-1.878 3.229 3.645 3.645 0 0 0 2.034 3.369c.291.175.593.356.593.751 0 .258-2.06 5.8-5.051 5.8a4.062 4.062 0 0 1-1.706-.414 3.459 3.459 0 0 0-1.518-.366 3.905 3.905 0 0 0-1.2.325 5.888 5.888 0 0 1-2.085.486z",
    transform: "translate(-46.022 -113.091)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M259.123 0c.078 2.809-1.931 4.757-3.937 4.635A4.476 4.476 0 0 1 259.123 0z",
    transform: "translate(-246.526)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.cba94b70.svg";
export { ForwardRef as ReactComponent };